import routes from './dictionary.routes';

export const dictionaryModule = {
    routes
};